<template>
    <router-link :to="{name: 'UserForm', params: { id: local_userform.id } }">
        <div
            class="form-card"
        >
            <v-card-text>
                <v-layout>
                    <v-flex
                        xs12
                        sm6
                        md3
                    >
                        <b>{{ local_userform.name }}</b><br />
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                        md3
                    >
                        <span style="text-transform: capitalize;">{{local_userform.status}}</span>
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                        md3
                    >
                        {{ convertToLocal(local_userform.created_at) }}<br />
                        <small>{{ local_userform.created_by_name || 'System' }}</small>
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                        md3
                    >
                        {{ convertToLocal(local_userform.updated_at) }}<br />
                        <small>{{ local_userform.updated_by_name || 'System' }}</small>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <div
                v-if="local_userform.form_number || local_userform.party_name"
                style="background: rgba(0,0,0,0.01);padding:5px 10px 5px 10px;"
            >
                <span
                    v-if="local_userform.form_number"
                    style="font-weight:bold;"
                >
                    {{ local_userform.form_number || '' }}
                </span>
                <span
                    v-if="local_userform.form_number && local_userform.party_name"
                >
                    &nbsp;-&nbsp;
                </span>
                <span
                    v-if="local_userform.party_name"
                >
                    {{ local_userform.party_name || '' }}
                </span>
            </div>
            <div
                v-if="local_userform.tags.length > 0"
                style="background: rgba(0,0,0,0.05);padding: 5px;"
            >
                <span
                    v-for="tag in local_userform.tags"
                    :key="tag"
                >
                    <v-chip
                        label
                        small
                        :outline="tag.includes(':')"
                    >
                        {{tag}}
                    </v-chip>
                </span>
            </div>
        </div>
    </router-link>
</template>

<script>
import api from '@/api'

export default {
    name: 'UserFormRow',
    props: ['id', 'userform', 'contact', 'casetype', 'tag'],
    data () {
      return {
        local_userform: null,
        searching: false
      }
    },
		created () {
			if (this.userform) {
				this.local_userform = JSON.parse(JSON.stringify(this.userform))
			} else {
				if (this.id)
					this.fetch()
			}
		},
		methods: {
			fetch () {
				return "do nothing for now"
			}
		}
}

</script>

<style scoped>

.form-card {
  transition: background 0.5s;
  cursor: pointer;
}

.form-card:hover {
  background: rgba(0,0,0,0.1);
}

a {
    text-decoration: none;
    color: black;
}
</style>